import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            See how footfall and dwell-time change across the selected retail centre.
            This helps you understand how people use the area and whether it's a good fit for your store
        </>
    );
};

export default Subtitle;
